/**
 * PDF utility functions for contract signing
 */

/**
 * Creates a blob URL from a Blob object
 * @param blob - The blob to create a URL for
 * @returns The blob URL string
 */
export function createBlobUrl(blob: Blob): string {
  return URL.createObjectURL(blob);
}

/**
 * Revokes a blob URL to free up memory
 * @param url - The blob URL to revoke
 */
export function revokeBlobUrl(url: string | null): void {
  if (url) {
    URL.revokeObjectURL(url);
  }
}

/**
 * Downloads a PDF blob as a file
 * @param blob - The PDF blob to download
 * @param filename - The filename for the download (default: "contract.pdf")
 */
export function downloadPdfBlob(blob: Blob, filename: string = "contract.pdf"): void {
  const url = createBlobUrl(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoke URL after a short delay to ensure download starts
  setTimeout(() => revokeBlobUrl(url), 100);
}

